import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    const data = await login(form.email, form.password);
    setLoading(false);
    if (data.success) navigate('/');
    else setError(data.error || 'Login failed');
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-logo">
          <div className="logo-icon" style={{ width: 52, height: 52, background: 'linear-gradient(135deg,#ff6b00,#ff8c3a)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800, fontSize: 24, margin: '0 auto 12px' }}>φ</div>
          <div style={{ fontWeight: 700, fontSize: 20, color: 'var(--secondary)' }}>PhysicsAI Tutor</div>
        </div>
        <h2>Welcome Back</h2>
        <p>Sign in to continue your physics journey</p>

        {error && <div className="alert alert-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">Email Address</label>
          <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input className="form-input" type="password" placeholder="Your password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        </div>
        <button className="btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '13px', fontSize: 15, borderRadius: 10, marginTop: 8 }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In →'}
        </button>

        <div className="auth-footer" style={{ marginTop: 24 }}>
          Don't have an account? <Link to="/register">Sign up free</Link>
        </div>
      </div>
    </div>
  );
}
